export default __webpack_public_path__ + "static/media/imghomepagebanner 4.6a6e36a7.webp";